/* Ayọ theme — interactions (no SPA; real Shopify pages) */
(function(){
  var hdr = document.getElementById('hdr');
  function onScroll(){
    if(!hdr) return;
    if(window.scrollY > 24){ hdr.classList.add('solid'); hdr.classList.remove('at-top'); }
    else { hdr.classList.remove('solid'); hdr.classList.add('at-top'); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  // mobile burger
  var burger = document.querySelector('.burger');
  var navlinks = document.getElementById('navlinks');
  if(burger && navlinks){
    burger.addEventListener('click', function(){ navlinks.classList.toggle('open'); });
  }

  // cart toast (preview — real cart follows)
  var n = 0, tt;
  var toastEl = document.getElementById('toast');
  window.ayoToast = function(m){
    if(!toastEl) return;
    toastEl.textContent = m;
    toastEl.classList.add('show');
    clearTimeout(tt);
    tt = setTimeout(function(){ toastEl.classList.remove('show'); }, 2600);
  };
  window.ayoAdd = function(){
    n++;
    var c = document.getElementById('cartn');
    if(c) c.textContent = n;
    window.ayoToast('Zum Warenkorb hinzugefügt (Vorschau)');
  };
  var cart = document.querySelector('.cart');
  if(cart){ cart.addEventListener('click', function(){ window.ayoToast('Warenkorb ist in der Vorschau noch nicht aktiv'); }); }

  // hero "Dein Café" colour cycle on hover
  var a = document.getElementById('heroAyo');
  if(a){
    var col = ['#C4541C','#2E86C1','#8DB85F'], i = 0;
    a.addEventListener('mouseenter', function(){ a.style.color = col[i%3]; i++; });
    a.addEventListener('mouseleave', function(){ a.style.color = ''; });
  }

  // shop category filter
  var chips = document.querySelectorAll('.shop-filter .chip');
  if(chips.length){
    var cats = document.querySelectorAll('#page-shop .shop-cat');
    cats.forEach(function(s){ /* data-cat set in markup */ });
    window.shopFilter = function(f){
      document.querySelectorAll('.shop-filter .chip').forEach(function(c){ c.classList.toggle('active', c.dataset.f === f); });
      cats.forEach(function(s){ s.style.display = (f === 'all' || s.dataset.cat === f) ? '' : 'none'; });
    };
  }

  // cookie consent banner
  (function(){
    var KEY = 'ayo_cookie_consent';
    var banner = document.getElementById('ccBanner');
    var reopen = document.getElementById('ccReopen');
    if(!banner) return;

    function applyShopify(granted){
      try{
        if(window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent){
          window.Shopify.customerPrivacy.setTrackingConsent({
            analytics: granted, marketing: granted, preferences: granted, sale_of_data: granted
          }, function(){});
        }
      }catch(e){}
    }
    function stored(){
      try{ return JSON.parse(localStorage.getItem(KEY) || 'null'); }catch(e){ return null; }
    }
    function save(level){
      var granted = (level === 'all');
      try{ localStorage.setItem(KEY, JSON.stringify({level:level, ts:Date.now()})); }catch(e){}
      applyShopify(granted);
    }
    function show(){ banner.hidden = false; }
    function hide(){ banner.hidden = true; }

    var prev = stored();
    if(prev){ applyShopify(prev.level === 'all'); }
    else { show(); }

    banner.addEventListener('click', function(e){
      var btn = e.target.closest('.cc-btn');
      if(!btn) return;
      save(btn.dataset.cc === 'all' ? 'all' : 'essential');
      hide();
    });
    if(reopen){
      reopen.addEventListener('click', function(e){ e.preventDefault(); show(); });
    }
  })();

  // café menu toggle: Speisen / Getränke
  var mt = document.getElementById('menuToggle');
  if(mt){
    mt.addEventListener('click', function(e){
      var btn = e.target.closest('.mt-btn');
      if(!btn) return;
      var which = btn.dataset.menu;
      mt.querySelectorAll('.mt-btn').forEach(function(b){ b.classList.toggle('active', b === btn); });
      document.querySelectorAll('.menu-panel').forEach(function(p){
        var show = (p.dataset.panel === which);
        p.hidden = !show;
        if(show){ p.style.animation = 'none'; void p.offsetWidth; p.style.animation = ''; }
      });
    });
  }
})();
